<template>
  <SplitHeroBanner :image="blok.image" class="search-hero" :tag="tag">
    <h1 v-if="blok.title" class="title size-2xl">{{ blok.title }}</h1>
    <div class="standalone">
      <h2 v-if="blok.search_title" class="search-title size-s">
        {{ blok.search_title }}
      </h2>
        <PlacesSearchboxNoMap v-if="!cookiesAccepted && isGmapCookiesActivated" :location="'hero'" />
        <PlacesSearchbox v-else :location="'hero'" />
    </div>
    <StoryblokComponent v-if="blok.push?.length === 1" :blok="blok.push[0]" isHero />
  </SplitHeroBanner>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});

const datasourcesStore = useDatasourcesStore();
const cookiesAccepted = ref(false);
const isGmapCookiesActivated = datasourcesStore.getGmapCookiesActivated;

function initDidomi() {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    Didomi.getObservableOnUserConsentStatusForVendor("c:googlemap-Y7WNQBAF").subscribe(
      function (consentStatus) {
        cookiesAccepted.value = consentStatus;
      }
    );
  });
}

onMounted(() => {
  initDidomi();
});
</script>

<style lang="scss" scoped>
.search-hero {
  .title,
  .search-title {
    text-align: center;
    @include for-tablet-landscape-up {
      text-align: left;
    }
  }
  .title {
    line-height: 100%;

    @include for-tablet-landscape-up {
      font-size: 6.38vh;
    }
  }
}
.standalone {
  margin-top: 2rem;
  @include for-tablet-landscape-up {
    margin-top: 2.75rem;
  }
}
.search-title {
  margin-bottom: 1rem;
}
</style>
